import { History } from 'history'
import { combineReducers } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'

import auth from './auth/slice'
import agency from './agency/slice'
import app from './application/slice'
import calendar from './calendar/slice'
import managePost from './managePost/slice'
import duplicateModal from './modal/duplicatePost/slice'
import gridView from './gridView/slice'
import approvalModal from './modal/approvalPost/slice'
import project from './project/slice'
import preloader from './preloader/slice'
import transparentPreloader from './transparentPreloader/slice'
import billing from './billing/slice'
import skipApproval from './modal/skipApprovalPost/slice';
import notifications from './notifications/slice';
import hashtag from './hashtag/slice';
import calendarApproval from './calendar-approval/slice'

const RootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    agency,
    calendar,
    app,
    managePost,
    duplicateModal,
    approvalModal,
    project,
    preloader,
    gridView,
    transparentPreloader,
    billing,
    skipApproval,
    notifications,
    hashtag,
    calendarApproval
  })

export default RootReducer
